/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Chat_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Write your answer…" |
*
* @param {Practice_Session_Chat_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_chat_placeholder = /** @type {((inputs?: Practice_Session_Chat_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Chat_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Schrijf je antwoord…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écrivez votre réponse…")
	return /** @type {LocalizedString} */ ("Write your answer…")
});